import { ProdesegDropdown } from "../../../../components/prodeseg-dropdown/ProdesegDropdown";
import { ProdesegDropdownToggle } from "../../../../components/prodeseg-dropdown/ProdesegDropdownToggle";
import {
    ProdesegButton,
    ProdesegButtonEnumSizes,
    ProdesegButtonEnumTypes,
} from "../../../../components/ProdesegButton/ProdesegButton";
import { ReactComponent as IconComunicar } from "../../../../assets/img/icon/comunicar.svg";
import { ReactComponent as IconFlechaLargaLeft } from "../../../../assets/img/icon/flecha_larga_left.svg";
import { ReactComponent as IconFlechaLargaRight } from "../../../../assets/img/icon/flecha_larga_right.svg";
import { ProdesegDropdownMenu } from "../../../../components/prodeseg-dropdown/ProdesegDropdownMenu";
import { useWindowBreakpoints } from "../../../../custom-hooks/useWindowBreakpoints";
import { Carousel } from "reactstrap";
import { useProdesegAnnouncement } from "./useProdesegAnnouncement";
import { NEWS } from "../../menu/menu-items.constants";
import "./prodeseg-announcemnt.scss";
import { FIRST_TIME_LOGIN } from "../../../../components/prodeseg-dropdown/prodeseg-dropdown.constants";

export const ProdesegAnnouncement = () => {
    const { banners, activeIndex, next, previous, bannerSlides, isPlaying } = useProdesegAnnouncement();
    const { isDownSm, isDownMd } = useWindowBreakpoints();
    const isFirstTimeLogin = !!sessionStorage.getItem(FIRST_TIME_LOGIN);

    const formatNumberWithLeadingZero = (value: number) => (value < 10 ? `0${value}` : value);
    const getCurrentSlide = () => formatNumberWithLeadingZero(banners.length > 0 ? activeIndex + 1 : activeIndex);
    const getTotalSlides = () => formatNumberWithLeadingZero(banners.length);

    const activateModal = isDownMd;

    return (
        <ProdesegDropdown
            position={"top"}
            align={"left"}
            activateModal={activateModal}
            arrowClassName={"announcement__arrow"}
        >
            <ProdesegDropdownToggle>
                <ProdesegButton
                    type={ProdesegButtonEnumTypes.Dark}
                    Icon={IconComunicar}
                    hideIconStart
                    className={`${isDownMd ? "border-0" : "mb-3"}`}
                    onlyIcon={isDownMd}
                    onClick={next}
                >
                    {NEWS}
                </ProdesegButton>
            </ProdesegDropdownToggle>
            <ProdesegDropdownMenu
                showCloseButton
                iconCloseStyle={{ right: "6px", top: "2px" }}
                iconCloseButtonType={ProdesegButtonEnumTypes.Primary}
                className="prodeseg-announcement"
                initialIsOpen={isFirstTimeLogin}
                activateModal={activateModal}
            >
                <div
                    className={"d-flex flex-column gap-4 py-4"}
                    style={{ width: isDownSm || activateModal ? "unset" : "325px" }}
                >
                    <Carousel
                        interval={isPlaying ? false : 5000}
                        activeIndex={activeIndex}
                        next={next}
                        previous={previous}
                    >
                        {bannerSlides}
                    </Carousel>
                    <div className={"pl-4 pr-4-2"}>
                        <div className={"announcement__separator"} />
                    </div>
                    <div className="d-flex justify-content-between align-items-center gap-3 pl-4 pr-4-2">
                        <span className="fw-semibold text-neutral-700 font-italic">{`${getCurrentSlide()}/${getTotalSlides()}`}</span>
                        <div className="d-flex gap-2-1">
                            <ProdesegButton
                                type={ProdesegButtonEnumTypes.Primary}
                                size={ProdesegButtonEnumSizes.Small}
                                hideIconEnd
                                isOutline
                                Icon={IconFlechaLargaLeft}
                                onClick={previous}
                            >
                                Anterior
                            </ProdesegButton>
                            <ProdesegButton
                                type={ProdesegButtonEnumTypes.Primary}
                                size={ProdesegButtonEnumSizes.Small}
                                hideIconStart
                                Icon={IconFlechaLargaRight}
                                onClick={next}
                            >
                                Siguiente
                            </ProdesegButton>
                        </div>
                    </div>
                </div>
            </ProdesegDropdownMenu>
        </ProdesegDropdown>
    );
};
